import * as ko from "knockout";
import template from "./../templates/bao-color-picker.html";
var vm = function (params) {
    var self = this;
    self.Selection = ko.observable();
    self.Colors = ko.observableArray(["black", "#dff0d8", "#fcf8e3", "#f2dede", "#d9edf7"]);
    if (params) {
        if (params.colors && ($.isArray(params.colors) || ko.isObservable(params.colors))) {
            var colors = ko.toJS(params.colors);
            if ($.isArray(colors)) {
                self.Colors.valueWillMutate();
                self.Colors.removeAll();
                ko.utils.arrayForEach(colors, function (c) {
                    var colorFound = ko.utils.arrayFirst(self.Colors(), function (cc) {
                        return cc === c;
                    });
                    if (!colorFound) {
                        self.Colors.push(c);
                    }
                });
                self.Colors.valueHasMutated();
            }
        }
        if (params.value && ko.isObservable(params.value)) {
            var initialValue = params.value();
            self.Selection(!initialValue ? "black" : initialValue);
            self.Selection.subscribe(function (color) {
                if (color === "black") {
                    params.value(null);
                }
                else {
                    params.value(color);
                }
            });
        }
    }
};
export default {
    viewModel: vm,
    template: template
};